// @ts-nocheck
/* eslint-disable */
export const boldMonitorIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 16"><path fill="currentColor" d="M12.03 1.333H4.598c-1.62 0-2.94 1.32-2.94 2.94V8.74a2.94 2.94 0 0 0 2.94 2.94h2.56c.367 0 .667.3.667.667v.646c0 .367-.3.667-.667.667H5.544a.504.504 0 0 0 0 1.007h5.567c.273 0 .5-.227.5-.5 0-.274-.227-.5-.5-.5H9.497A.67.67 0 0 1 8.831 13v-.647c0-.366.3-.666.666-.666h2.54a2.94 2.94 0 0 0 2.94-2.94V4.28a2.956 2.956 0 0 0-2.946-2.947"/></svg>`,
    name: 'bold-monitor' as const
};